import * as React from "react";

const CalenderFill = (props) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.813 16.79V5.487c0-.89-.688-1.614-1.534-1.614h-1.534V2.257H12.21v1.615H7.608V2.257H6.074v1.615H4.54c-.847 0-1.535.724-1.535 1.614v11.305c0 .89.688 1.615 1.535 1.615h10.739c.846 0 1.534-.724 1.534-1.615Zm-9.205-1.614H6.074v-1.615h1.534v1.615Zm0-3.23H6.074v-1.615h1.534v1.615Zm3.068 3.23H9.142v-1.615h1.534v1.615Zm0-3.23H9.142v-1.615h1.534v1.615Zm3.069 3.23H12.21v-1.615h1.535v1.615Zm0-3.23H12.21v-1.615h1.535v1.615Zm1.534-4.037H4.539V6.294h10.74v1.615Z"
      fill="currentColor"
    />
  </svg>
);

export default CalenderFill;
